import type { BenefitsStageboxSubtitleProps } from './types';
import styles from './BenefitsStageboxSubtitle.module.scss';
import clsx from 'clsx';
import { getSafeInnerHTMLProp } from '@/helpers/getSafeInnerHTML';

const BenefitsStageboxSubtitle = ({
  children,
  className,
}: BenefitsStageboxSubtitleProps) => {
  return (
    <div
      className={clsx(styles.base, className)}
      {...getSafeInnerHTMLProp(children)}
    />
  );
};

export default BenefitsStageboxSubtitle;
